import React, { memo, useCallback } from 'react'

import { Icon, InputUI } from '@fourthwall/components'
import { ArrowShortDownIcon, CloseIcon } from '@fourthwall/icons'

type CategoryActionIconProps = {
  isInputActive: boolean
  hasValue: boolean
  disabled?: boolean
  onReset: () => void
  onSelect: () => void
}

export const CategoryActionIcon = memo(
  ({ isInputActive, hasValue, disabled, onReset, onSelect }: CategoryActionIconProps) => {
    const iconType = isInputActive && hasValue ? 'reset' : 'select'
    const icon = iconType === 'reset' ? CloseIcon : ArrowShortDownIcon

    const handleClick = useCallback(() => {
      if (disabled) return

      if (iconType === 'reset') {
        onReset()

        return
      }

      onSelect()
    }, [isInputActive, iconType, onReset, onSelect])

    return (
      <InputUI.ActionIconContainer
        $size="large"
        $hoverable={!disabled}
        data-testid="Input.ActionIcon"
        onClick={handleClick}
      >
        <Icon component={icon} height={15} />
      </InputUI.ActionIconContainer>
    )
  },
)
